let random = Math.round(Math.random() * 10000);
const PasWord = function(options, random) {
    const basicParam = { //服务器交互基本参数
        spid: "619379435910168",
        channel: "4",
        format: "JSON",
        oper: "127.0.0.1",
        random: random,
        source: 'BJYH',
    };
    const _options = Object.assign(options, basicParam);
    const str = JSON.stringify(_options);
    return hex_md5(hex_md5("aAr9MVS9j1") + str);
};
const basicParam = { //服务器交互基本参数
    spid: "619379435910168",
    channel: "4",
    format: "JSON",
    oper: "127.0.0.1",
    random: random,
    source: 'BJYH',

};
let upLoadBasicParam = {
    spid: "619379435910168",
    channel: "4",
    format: "JSON",
    oper: "127.0.0.1",
    random: Math.round(Math.random() * 10000),
    source: 'BJYH',
};
upLoadBasicParam.sign = hex_md5(hex_md5("aAr9MVS9j1") + 1001 + upLoadBasicParam.random);
export { PasWord, basicParam, upLoadBasicParam };